webpackJsonp([188370110548916],{

/***/ 1623:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formik = __webpack_require__(10);
	
	var _yup = __webpack_require__(13);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _Alert = __webpack_require__(14);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _CheckboxGroup = __webpack_require__(17);
	
	var _CheckboxGroup2 = _interopRequireDefault(_CheckboxGroup);
	
	var _Input = __webpack_require__(9);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _RadioGroup = __webpack_require__(16);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Datetime = __webpack_require__(18);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignUpFormReview = function (_Component) {
	  _inherits(SignUpFormReview, _Component);
	
	  function SignUpFormReview(props) {
	    _classCallCheck(this, SignUpFormReview);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      formState: null
	    };
	    return _this;
	  }
	
	  SignUpFormReview.prototype.render = function render() {
	    var _this2 = this;
	
	    var formState = this.state.formState;
	    var _props = this.props,
	        classes = _props.classes,
	        className = _props.className;
	
	
	    var valid = function valid(current) {
	      return current.day() !== 0 && current.day() !== 6;
	    };
	
	    var renderDay = function renderDay(props, currentDate, selectedDate) {
	      if (currentDate.month() == (0, _moment2.default)().month()) {
	        if (currentDate.date() < (0, _moment2.default)().date()) {
	          if (props.className == "rdtDay") {
	            props.className = "rdtDay rdtDisabled";
	          }
	        }
	      }
	      if (currentDate.month() < (0, _moment2.default)().month()) {
	        props.className = "rdtDay rdtDisabled";
	      }
	
	      return _react2.default.createElement(
	        "td",
	        props,
	        currentDate.date()
	      );
	    };
	
	    if (formState === "success") {
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            maxWidth: "400px",
	            textAlign: "center",
	            margin: "24px auto"
	          }
	        },
	        _react2.default.createElement(
	          _Alert2.default,
	          { color: "success" },
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading4", gutterBottom: true },
	            "Congratulations, you\u2019ve just taken the 1st step to online marketing success."
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "heading6", gutterTop: true },
	            "We look forward to connecting with you."
	          )
	        )
	      );
	    } else if (formState === "error") {
	      return _react2.default.createElement(
	        "div",
	        { style: { maxWidth: "400px", margin: "24px auto" } },
	        _react2.default.createElement(
	          _Alert2.default,
	          { color: "error" },
	          "An error occurred."
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: (0, _classnames2.default)(classes.root, className) },
	      _react2.default.createElement(_formik.Formik, {
	        initialValues: {
	          firstname: "",
	          lastname: "",
	          company: "",
	          email: "",
	          phone: "",
	          role: "",
	          roleOther: "",
	          interests: [],
	          form: "socialmediareview",
	          list: 98511
	        },
	        validationSchema: function validationSchema() {
	          return Yup.object().shape({
	            firstname: Yup.string().required("First name is required"),
	            lastname: Yup.string().required("Last name is required"),
	            company: Yup.string(),
	            email: Yup.string().email("Invalid email address").required("Email is required"),
	            phone: Yup.string().required("Phone is required"),
	            role: Yup.string(),
	            roleOther: Yup.string(),
	            interests: Yup.array()
	          });
	        },
	        onSubmit: function onSubmit(values, _ref) {
	          var setSubmitting = _ref.setSubmitting;
	
	          var meeting_request = "";
	          Object.keys(values).forEach(function (key, index) {
	            // key: the name of the object key
	            // index: the ordinal position of the key within the object
	            if (key == "meetingdate") {
	              if (typeof values.meetingdate.format === "function") {
	                meeting_request = values.meetingdate.format("YYYY-MM-DD") + "T" + values.meetingtime.replace(" (EDT)", "") + "-04:00";
	              }
	            }
	          });
	          var body = _extends({}, values, {
	            roleOther: values.role === "Other" ? values.roleOther : "", // Just in case the user had typed in roleOther then changed their role to something else
	            interestStr: values.interests.join(",") + ", Interested Markets: " + values.market1 + ", " + values.market2 + "," + values.market3,
	            utm_campaign: window.utm_tags ? window.utm_tags.campaign : "",
	            utm_source: window.utm_tags ? window.utm_tags.source : "",
	            utm_medium: window.utm_tags ? window.utm_tags.medium : "",
	            utm_term: window.utm_tags ? window.utm_tags.term : "",
	            demo_request_date: meeting_request
	          });
	          return fetch("https://hooks.zapier.com/hooks/catch/4496703/3uy9gh0/", {
	            method: "POST",
	            body: JSON.stringify(body)
	          }).then(function (response) {
	            return response.json();
	          }).then(function (res) {
	            if (res.status === "success") {
	              _this2.setState({ formState: "success" });
	              dataLayer.push({ event: "form-success" });
	
	              if (window.fbq) {
	                window.fbq("track", "Lead");
	              }
	              if (window.gtag) {
	                window.gtag("event", "conversion", {
	                  send_to: "AW-980447970/2_aHCOnsjo8BEOLlwdMD"
	                });
	              }
	              if (window.ga) {
	                window.ga("send", "event", "form", "form_completed", "get-started");
	              }
	            } else {
	              _this2.setState({ formState: "error" });
	            }
	          }).catch(function (err) {
	            _this2.setState({ formState: "error" });
	          });
	        },
	        render: function render(_ref2) {
	          var values = _ref2.values,
	              isSubmitting = _ref2.isSubmitting,
	              handleBlur = _ref2.handleBlur,
	              handleChange = _ref2.handleChange;
	          return _react2.default.createElement(
	            _formik.Form,
	            { noValidate: true },
	            _react2.default.createElement(_Typography2.default, {
	              type: "heading6",
	              style: {
	                textAlign: "center",
	                marginBottom: "32px",
	                color: "#888f96"
	              }
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: classes.topRow },
	              _react2.default.createElement(_formik.Field, {
	                id: "firstname",
	                name: "firstname",
	                label: "First Name",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "lastname",
	                name: "lastname",
	                label: "Last Name",
	                component: _Input2.default,
	                className: classes.field
	              })
	            ),
	            _react2.default.createElement(_formik.Field, {
	              id: "email",
	              name: "email",
	              label: "Email",
	              component: _Input2.default,
	              className: classes.field
	            }),
	            _react2.default.createElement(_formik.Field, {
	              id: "phone",
	              name: "phone",
	              label: "Phone",
	              component: _Input2.default,
	              className: classes.field,
	              type: "tel"
	            }),
	            _react2.default.createElement(_formik.Field, {
	              id: "company",
	              name: "company",
	              label: "Affiliation (optional)",
	              component: _Input2.default,
	              className: classes.field
	            }),
	            _react2.default.createElement(_formik.Field, {
	              id: "mls_number",
	              name: "mls_number",
	              label: "MLS # (optional)",
	              component: _Input2.default,
	              className: classes.field
	            }),
	            _react2.default.createElement(_formik.Field, {
	              id: "role",
	              name: "role",
	              label: "I am:",
	              component: _RadioGroup2.default,
	              display: "inline",
	              items: [{
	                label: "An Existing Client",
	                value: "Existing Client"
	              }, {
	                label: "An Agent",
	                value: "Agent"
	              }, {
	                label: "A Broker/Owner",
	                value: "Broker"
	              }, {
	                label: "Other (please specify)",
	                value: "Other"
	              }],
	              className: classes.field
	            }),
	            values.role === "Other" && _react2.default.createElement(_formik.Field, {
	              id: "roleOther",
	              name: "roleOther",
	              label: "Other",
	              component: _Input2.default,
	              className: classes.field,
	              autoFocus: true
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                type: "submit",
	                className: classes.signUpBtn,
	                disabled: isSubmitting
	              },
	              "Please contact me asap"
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  fontSize: "11px",
	                  lineHeight: "16px",
	                  textAlign: "center"
	                }
	              },
	              "By submitting this form, you are requesting to be contacted by a member of the Elevate Sales Team at the details provided via text, email or call (may involve automated or pre-recorded means). You may revoke this consent through any reasonable means."
	            )
	          );
	        }
	      })
	    );
	  };
	
	  return SignUpFormReview;
	}(_react.Component);
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      maxWidth: "600px",
	      backgroundColor: "#f7f7f7 !important",
	      margin: "0 auto"
	    },
	    link: {
	      color: "inherit"
	    },
	    field: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "50px",
	      fontWeight: "600"
	    },
	    topRow: {
	      display: "flex",
	      flexDirection: "row",
	      justifyContent: "space-between",
	
	      "& > * + *": {
	        marginLeft: "12px"
	      }
	    },
	    signUpBtn: {
	      width: "100%",
	      fontSize: "20px",
	      lineHeight: "26px",
	      fontWeight: "600",
	      color: "#FFF",
	      backgroundColor: theme.colors.secondary,
	      borderRadius: "6px",
	      padding: "12px",
	      margin: "14px 0"
	    },
	    selectfield: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "40px"
	    },
	    selectlabel: {
	      width: "100%",
	      color: "#888f96",
	      display: "flex",
	      fontSize: "14px",
	      alignItems: "center",
	      lineHeight: "18px",
	      fontWeight: "700",
	      marginBottom: "4px"
	    }
	  };
	})(SignUpFormReview);
	module.exports = exports["default"];

/***/ }),

/***/ 3210:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/smr_header.d6accfe5.jpg";

/***/ }),

/***/ 1729:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _SignUpFormReview = __webpack_require__(1623);
	
	var _SignUpFormReview2 = _interopRequireDefault(_SignUpFormReview);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _smr_header = __webpack_require__(3210);
	
	var _smr_header2 = _interopRequireDefault(_smr_header);
	
	var _ResponsiveVid = __webpack_require__(21);
	
	var _ResponsiveVid2 = _interopRequireDefault(_ResponsiveVid);
	
	var _wowad_bottom = __webpack_require__(1230);
	
	var _wowad_bottom2 = _interopRequireDefault(_wowad_bottom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialMediaReview = function SocialMediaReview(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      data = _ref.data,
	      tags = _ref.tags;
	
	  var postNode = {
	    title: "Social Media Review - " + _siteConfig2.default.siteTitle
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Social Media Review - " + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { postNode: postNode, pagePath: "SocialMediaReview", customTitle: true }),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { maxWidth: "900px", backgroundColor: "#f7f7f7", marginRight: "auto", marginLeft: "auto" } },
	          _react2.default.createElement("img", { src: _smr_header2.default, style: { width: "100%" } }),
	          _react2.default.createElement(
	            "div",
	            { style: { marginBottom: "20px", paddingTop: "55px", paddingRight: "60px", paddingLeft: "60px" } },
	            _react2.default.createElement(
	              "div",
	              { className: classes.headingLarge, style: { marginBottom: "25px" } },
	              "FREE Social Media Review"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { color: "#495050", lineHeight: "25px", paddingBottom: "15px", textAlign: "center" } },
	              "Spend 15-minutes with an Elevate Success Coach who will review your website, blog and social channels with you and give you tips, tricks & strategies for making the most of your online marketing NOW and in the FUTURE. No string attached."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { paddingLeft: "40px", paddingRight: "40px", paddingBottom: "60px" } },
	            _react2.default.createElement(_SignUpFormReview2.default, null)
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _fullWidthVid;
	
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      padding: "0 8px",
	      margin: "70px auto"
	    },
	    heading: {
	      fontSize: "28px",
	      fontWeight: "800",
	      letterSpacing: ".14px",
	      color: "#2E2E35",
	      textAlign: "center",
	      marginBottom: "12px"
	    },
	    headingLarge: {
	      fontSize: "33px",
	      fontWeight: "700",
	      color: "#5bc0b8",
	      textAlign: "center",
	      padding: "3px",
	      lineHeight: "38px"
	    },
	
	    subHeading: {
	      fontSize: "18px",
	      lineHeight: "28px",
	      letterSpacing: ".08px",
	      textAlign: "center",
	      margin: "0 auto 36px"
	    },
	    landingHeaderStyle: {
	      textAlign: "center",
	      marginBottom: "30px"
	    },
	    fullWidthVid: (_fullWidthVid = {
	      width: "100%",
	      marginLeft: "auto",
	      marginRight: "auto"
	    }, _fullWidthVid[theme.breakpoints[900]] = {
	      width: "75%"
	    }, _fullWidthVid)
	  };
	})(SocialMediaReview);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-socialmediareview-js-9613259a23f5fa1a253d.js